// Tiny pub/sub so the global assistant can know which studio tab the user is on
// (tab state lives inside Dashboard, not the URL) and how long they've been there.
let current = { tab: null, since: 0 };
let suppressNudge = false;
const listeners = new Set();

export function setStudioTab(tab) {
  current = { tab, since: Date.now() };
  listeners.forEach((fn) => fn(current));
}

export function getStudioTab() {
  return current;
}

export function subscribeStudioTab(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Let focused workspaces (e.g. Long Film director) hide the proactive nudge
// bubble so it never overlaps their primary CTAs.
export function setNudgeSuppressed(v) {
  suppressNudge = !!v;
  listeners.forEach((fn) => fn(current));
}

export function isNudgeSuppressed() {
  return suppressNudge;
}

// Let the assistant drive the studio to a specific tab (image/video/…) so it
// can take the user straight to the right tool.
const tabRequestListeners = new Set();

export function requestStudioTab(tab) {
  tabRequestListeners.forEach((fn) => fn(tab));
}

export function subscribeTabRequest(fn) {
  tabRequestListeners.add(fn);
  return () => tabRequestListeners.delete(fn);
}

// Request a specific model to open (used by the tutorial)
const modelRequestListeners = new Set();

export function requestModelOpen({ key, mediaType, prompt }) {
  modelRequestListeners.forEach((fn) => fn({ key, mediaType, prompt }));
}

export function subscribeModelRequest(fn) {
  modelRequestListeners.add(fn);
  return () => modelRequestListeners.delete(fn);
}

// Carry voiceover prefill
let voiceoverPrefill = null;

export function setVoiceoverPrefill(payload) {
  voiceoverPrefill = payload;
  requestStudioTab("audio");
}

export function consumeVoiceoverPrefill() {
  const p = voiceoverPrefill;
  voiceoverPrefill = null;
  return p;
}


